import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const resetErrorMessage = createAction('@@error/RESET_ERROR_MESSAGE');
